/**
 * Funzione per la creazione di una validazione asincrona.
 * Attenzione: per limitazioni techiche, utilizzare questa funzione come unico elememento dell'array di validazione.
 * Se ci sono altre valiadzioni, queste potrebbero creare dei problemi in fase di inizializzazione della form, quando questa non sia valida.
 *
 * Funzione deprecata. Utilizzare validations di input v2. Verrà rimossa in una prossima versione.
 * @param func funzione che ritorna una promise
 * @param validateFuncOrRef ref al componente al quale forzare la validazione
 * @returns validazione da passare al componente
 * @deprecated
 */
function createAsyncValidator(func) {
    return func;
}

export { createAsyncValidator as default };
